/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InteraccionFarmacoModelDto } from '../../models/interaccion-farmaco-model-dto';

export interface FarmacosControllerInteraccionFarmacoPaciente$Params {

/**
 * UUID del programa al que pertenece el paciente
 */
  programaUuid: string;

/**
 * UUID del fármaco a comprobar
 */
  farmacoUuid: string;
}

export function farmacosControllerInteraccionFarmacoPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionFarmacoModelDto>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerInteraccionFarmacoPaciente.PATH, 'post');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
    rb.path('farmacoUuid', params.farmacoUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InteraccionFarmacoModelDto>;
    })
  );
}

farmacosControllerInteraccionFarmacoPaciente.PATH = '/api/farmacos/farmacos-paciente-interacciones/{programaUuid}/{farmacoUuid}';
